import { Injectable } from '@angular/core';
import {
  ANALYTICS_EVENTS,
  EVENT_CLICK_TYPE,
  HEADER_MENU,
  USER_LOGGED_IN_STATUS
} from '../../constants/utils';
import {
  AnalyticsSiteAssets,
  ClickEventAnalytics
} from '../../models/utils/analytics.interfaces';
import { ContentBodyExtendedAdobeAnalyticsService } from './content-body-extended-adobe-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class ContentBodyCoreAdobeAnalyticsUtil extends ContentBodyExtendedAdobeAnalyticsService {
  setHomePageClickEventAnalytics(cardDiv: Element, eventDetail: string): void {
    if (!cardDiv) return;
    cardDiv.addEventListener('click', (event) =>
      this.handleCardClick(event, eventDetail)
    );
  }

  handleCardClick(event: Event, eventDetail: string): void {
    const clickedElement = event.target as HTMLElement;
    const closestAnchor = clickedElement.closest('a');
    if (!closestAnchor) return;

    event.preventDefault();

    const headerText = this.getHeaderText(closestAnchor);
    const eventType = event.type;
    const fullUrl = this.getFullUrl(closestAnchor);

    this.setHomePageClickAnalytics(headerText, eventType, fullUrl, eventDetail);

    window.location.href = fullUrl;
  }

  getHeaderText(anchor: HTMLAnchorElement): string {
    const isComponentLink = this.isComponentLink(anchor);
    return isComponentLink
      ? anchor.querySelector('span,h3')?.textContent || ''
      : anchor.textContent || '';
  }

  isComponentLink(anchor: HTMLAnchorElement): boolean {
    return (
      anchor.classList.length > 0 &&
      ((anchor.classList.contains('componentLink') &&
        anchor.classList.contains('block')) ||
        anchor.classList.value.trim() ===
          'card-component flex-adjust  componentLink')
    );
  }

  getFullUrl(anchor: HTMLAnchorElement): string {
    const href = anchor.getAttribute('href') || '';
    return new URL(href, window.location.origin).href;
  }

  setHomePageClickAnalytics(
    headerText: string,
    eventType: string,
    fullUrl: string,
    eventDetail: string
  ): void {
    const data: ClickEventAnalytics = {
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: eventDetail,
      click: {
        name: ANALYTICS_EVENTS.RIGHT_ARROW,
        type: eventType,
        page_section: HEADER_MENU.HOMEPAGE.PAGE_SECTION,
        action: fullUrl,
        tile_name: headerText
      },
      user: {
        attributes: {
          is_logged_in: this.isLoggedInGlobal
            ? USER_LOGGED_IN_STATUS.AUTHENTICATED
            : USER_LOGGED_IN_STATUS.UNAUTHENTICATED
        }
      }
    };
    this.analyticsService.setAnalytics(data);
  }

  setHomePageSiteAssetsAnalytics(
    cardDiv: Element,
    eventDetail: string
  ): AnalyticsSiteAssets[] {
    if (!cardDiv) return [];
    let position = 1;
    const site_assets_array: AnalyticsSiteAssets[] = [];

    const relevantElements = Array.from(
      cardDiv.querySelectorAll('h3, span, a')
    ).filter((element) => {
      const hasText = element.textContent?.trim();
      const isRelevantClass = [
        'card-headertxt',
        'card-title brand-head-home'
      ].includes(element.className);
      return hasText && isRelevantClass;
    });

    const newAssets = relevantElements.map((element) => ({
      name: element.textContent?.trim() || '',
      type: eventDetail,
      position: `${position++}`
    }));

    site_assets_array.push(...newAssets);
    return site_assets_array;
  }

  setLoginGlobalStatus(loggedInStatus: boolean): void {
    this.isLoggedInGlobal = loggedInStatus;
    const data: ClickEventAnalytics = {
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: this.getLoggedInStatus(this.isLoggedInGlobal),
      click: {
        name: this.getLoggedInStatus(this.isLoggedInGlobal),
        type: EVENT_CLICK_TYPE.BUTTON,
        page_section: HEADER_MENU.HOMEPAGE.PAGE_SECTION,
        action: this.getLoggedInStatus(this.isLoggedInGlobal)
      },
      user: {
        attributes: {
          is_logged_in: this.isLoggedInGlobal
            ? USER_LOGGED_IN_STATUS.AUTHENTICATED
            : USER_LOGGED_IN_STATUS.UNAUTHENTICATED
        }
      }
    };
    this.analyticsService.setAnalytics(data);
  }

  getLoggedInStatus(loggedInStatus: boolean): string {
    return loggedInStatus
      ? USER_LOGGED_IN_STATUS.LOGIN_SUCCESS
      : USER_LOGGED_IN_STATUS.LOGIN_FAILURE;
  }
}
